export const companyDetailsHeaders = [
  { id: 'member', title: 'member', width: '250px' },
  { id: 'role', title: 'role', width: '200px' },
];
